import React from 'react';
import IconLogo from '../icons/IconLogo';
import s from './LogoComponent.module.css';
import UndoButton from '../undo-button/UndoButton';
import { useNavigate } from 'react-router-dom';
const LogoComponent = () => {
    const navigate = useNavigate();
    return (
        <div className={s.logo_wrapper}>
            <div className={s.logo_container} onClick={() => navigate('/dashboard')}>
                <IconLogo />
                <p className={s.logo_text}>SimpleCreate</p>
            </div>
        </div>
    );
};

export default LogoComponent;
